// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
.modal__overlay {
  z-index: 998;
  background: var(--c_mainOverlayBackground);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.modal {
  z-index: 999;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}
.modal__container {
  max-width: 600px;
  min-width: 300px;
  padding: var(--m_components);
  background: var(--c_backgroundBox);
  box-shadow: rgba(102, 119, 136, 0.1) 0 2px 8px 2px, rgba(102, 119, 136, 0.3) 0 1px 2px;
  pointer-events: auto;
  border-radius: 16px;
  text-align: center;
}
@media screen and (max-width: 905px) {
  .modal__container {
    margin: 0 8px;
  }
}
.modal__container .cancel {
  text-align: right;
}
.modal__container .cancel visiba-svg {
  width: 20px;
}
.modal__container .cancel visiba-svg:hover {
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
